import { React } from 'react';

interface LogoProps {
  size?: number;
  color?: string;
  strokeWidth?: number; 
}

const ZigLogo = ({ size = 24, color = "currentColor", strokeWidth = 1.5 }: LogoProps) => {
  return (
<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
  <path
    fill={color}
    // stroke={color} 
    strokeWidth={strokeWidth} 
    d="m23.53 1.02-7.686 3.45h-7.06l-2.98 3.452h7.173L.47 22.98l7.681-3.607h7.065v-.002l2.978-3.45-7.148-.001 12.482-14.9zM0 4.47v14.901h1.883l2.98-3.45H3.451v-8h.942l2.824-3.45H0zm22.117 0-2.98 3.608h1.412v7.844h-.942l-2.98 3.45H24V4.47h-1.883z" />
  </svg>
);
};

export default ZigLogo;